import { createContext, ReactNode, useContext, useMemo, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { trackerApi } from '../api/TrackerApi';
import { AppUserDto } from '../auth/AuthentificationQuery';
import { setAppContext } from './AppContextReducer';
import { AppState } from './AppReducer';
import appRoutesConfig from './AppRoutesConfig';
import AppRoutesUtil from './AppRoutesUtil';
import { useQueryClient } from 'react-query';

export interface AppContextType {
    user: AppUserDto,
    // status: AppStatusDto
    isAuthenticated: boolean,
    isPasswordConfirmed: boolean,
    defaultUrl: string,
    login: (appUser: AppUserDto) => Promise<void>,
    logout: () => void,
    checkTokenExpirationDate: () => void,
    language: "en" | "fr"
    // appDomainId: AppDomainEnum
}

const AppContext = createContext<AppContextType>({} as AppContextType);

const { Provider } = AppContext

interface AppProviderProps {
    children: ReactNode,
    defaultUrl: string,
    defaultLanguage: "en" | "fr"
    // appDomainId: AppDomainEnum
}

export const AppContextProvider = (props: AppProviderProps) => {

    const dispatch = useDispatch()

    const queryClient = useQueryClient()

    const { context } = useSelector((state: AppState) => state?.appContext)


    const [userInfo, setUserInfo] = useState<AppUserDto>(context?.user)

    // const [appStatus, setAppStatus] = useState<AppStatusDto>(context.status)

    const [isAuthenticated, setIsAuthenticated] = useState(context?.isAuthenticated)

    // const mutateUserInfo = useMutationUserInfo();

    // const mutateAppStatus = useMutationAppStatus();

    const logoutUser = () => {

        if (!isAuthenticated)
            return;

        trackerApi.resetToken();

        setUserInfo({} as AppUserDto)

        
        // setAppStatus({} as AppStatusDto)

        queryClient.clear()

        setIsAuthenticated(false);
    }

    const loginUser = async (appUser: AppUserDto) => {

        trackerApi.updateToken(appUser.token)

        setUserInfo(appUser)
        // await mutateUserInfo().then((userInfo: UserInfoDto) => setUserInfo(userInfo))

        // await mutateAppStatus(process.env.REACT_APP_DISPLAY_NAME ?? '').then((appStatus: AppStatusDto) => setAppStatus(appStatus));

        setIsAuthenticated(true);
    }

    const checkTokenExpirationDate = () => {
        if (isAuthenticated) {
            if ((new Date()).getTime() > new Date(userInfo?.tokenExpireTime).getTime()) {
                setIsAuthenticated(false);
            }
        }
    }

    const memoizedAppContext = useMemo(
        () => {

            // if (isAuthenticated)
            AppRoutesUtil.generateRoutesFromCustomRoutes(appRoutesConfig, props.defaultUrl)
            // else
            //     AppRoutesUtil.resetRoutes()

            const context = {
                user: userInfo,
                status: [], //appStatus,
                isAuthenticated: isAuthenticated,
                isPasswordConfirmed: false, //userInfo?.passwordConfirmed,
                defaultUrl: props.defaultUrl,
                login: loginUser,
                logout: logoutUser,
                checkTokenExpirationDate: checkTokenExpirationDate,
                appDomainId: 0, //props.appDomainId,
                language: props.defaultLanguage
            }

            // if (!isUndefined(userInfo?.token))
            //     inoksWebApi.updateToken(userInfo?.token)

            dispatch(setAppContext(context))

            // console.log("Memoized Context", context);

            return context
        },
        // eslint-disable-next-line react-hooks/exhaustive-deps
        [userInfo, isAuthenticated]
    )

    return (
        <Provider value={memoizedAppContext}>
            {props.children}
        </Provider>
    )
}

export const useAppContext = () => useContext(AppContext)